import { render } from "./BirthInfos.vue?vue&type=template&id=3b0b3bdd&scoped=true"
import script from "./BirthInfos.vue?vue&type=script&lang=js"
export * from "./BirthInfos.vue?vue&type=script&lang=js"

import "./BirthInfos.vue?vue&type=style&index=0&id=3b0b3bdd&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0b3bdd"]])

export default __exports__